import { getRegionPie } from "@/api/operate";

export default {
  data() {
    return {
      pieChartData: [],
    };
  },
  methods: {
    // 获取饼图数据
    getRegionPie() {
      getRegionPie({
        search: JSON.stringify(
          this.isRegion
            ? {
                Shop: this.info.region,
              }
            : { Region: this.info.region }
        ),
      }).then((rows) => {
        if (this.isRegion) {
          rows = rows.filter((v) => v.Shop === this.info.region);
        }
        this.pieChartData = this.formatPieChartData(rows);
      });
    },
    formatPieChartData(rows) {
      let ret = [];
      rows.forEach((row) => {
        const index = ret.findIndex((v) => v.name === row.VIPLevel);
        if (index === -1) {
          ret.push({ name: row.VIPLevel, value: row.Value });
        } else {
          ret[index].value += row.Value;
        }
      });
      return ret;
    },
  },
};
